import React from 'react';
import LookerFrame from './LookerFrame';
import { Auth, API } from 'aws-amplify';

class Client extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDashboard: {
                id: 0,
                title: ""
            },
            dashboards: []
        };
    }

    setActiveDashboard = async (dash) => {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(currentSession.refreshToken, async (err, session) => {
            console.log('session', err, session);
            const { accessToken } = session;

            const result = await this.getEmbedUrl(accessToken.jwtToken);
            console.log(result.url);
            this.setState({ view: "FRAME" });
            this.setState({ frameSrc: `https://${result.url}` });
            this.setState({ activeDashboard: dash });
        });
    }

    getEmbedUrl = async (accessToken) => {
        const apiName = 'lookersso';
        const path = '/embed';
        const myInit = {
            queryStringParameters: {
                accessToken: accessToken,
                dashKey: window.location.hostname.match(/^staging/) ? 748 : 751,
                domain: window.location.origin
            }
        };

        return await API.get(apiName, path, myInit);
    }

    getDashboards = async (accessToken) => {
        const apiName = 'lookersso';
        const path = '/dashboards';
        const myInit = {
            queryStringParameters: {
                accessToken: accessToken
            }
        };

        return await API.get(apiName, path, myInit);
    }

    componentDidMount() {
        const setDashboard = async () => {
            const user = await Auth.currentAuthenticatedUser();
            const session = await Auth.currentSession();
            this.getDashboards(session.accessToken.jwtToken).then(d => {
                    this.setState({
                        user: {
                            clientId: user.attributes["custom:ClientId"],
                            groups: session.accessToken.payload["cognito:groups"]
                        },
                        dashboards: d
                    });
    
                    this.setActiveDashboard(d[0]);
                });

        }

        setDashboard();

        const browserHeight = window.innerHeight;
        const headerHeight = document.getElementsByClassName("header")[0].offsetHeight;
        const footerHeight = document.getElementsByTagName("footer")[0].offsetHeight;
        const contentHeight = browserHeight - headerHeight - footerHeight - 20;
        document.getElementsByClassName("content")[0].style.height = `${contentHeight}px`;

    }

    render() {
        return (
            <div>
                <div className="content">
                    <LookerFrame frameSrc={this.state.frameSrc} />
                </div>
            </div>
        );
    }
}

export default Client;

